import ScalarToggleInput_vue_vue_type_script_setup_true_lang_default from "./ScalarToggleInput.vue_vue_type_script_setup_true_lang.js";
//#region src/components/ScalarToggle/ScalarToggleInput.vue
var ScalarToggleInput_default = ScalarToggleInput_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarToggleInput_default as default };

//# sourceMappingURL=ScalarToggleInput.vue.js.map